export default () => {
    const heroLoadAnimationComponent = document.getElementById('hero-load-animation');
    if (heroLoadAnimationComponent == null)
        return;
    //     console.log('id', heroLoadAnimationComponent)
    import(/* webpackChunkName: "hero load animation" */ "./../classes/heroLoadAnimationClass")
        .then(({ default: HeroLoadAnimationClass }) => {
        new HeroLoadAnimationClass();
    })
        .catch(() => "An error with case studies rive component occurred");
};
